import { render, staticRenderFns } from "./itinerary_air_3.vue?vue&type=template&id=179e1b46&scoped=true&"
import script from "./itinerary_air_3.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_3.vue?vue&type=script&lang=js&"
import style0 from "./itinerary_air_3.vue?vue&type=style&index=0&id=179e1b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179e1b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260415121604/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179e1b46')) {
      api.createRecord('179e1b46', component.options)
    } else {
      api.reload('179e1b46', component.options)
    }
    module.hot.accept("./itinerary_air_3.vue?vue&type=template&id=179e1b46&scoped=true&", function () {
      api.rerender('179e1b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_air_3.vue"
export default component.exports